export default "__VITE_ASSET__B7I0MjxZ__"